import AddressViewModel from '../locations/addressViewModel'

export default class ClientGroupOverviewViewModel {
  constructor({
    address = null,
    clientId,
    clientName,
    locationId,
    locationName,
    openBookings = 0,
    totalBookings = 0,
  } = {}) {
    /**
     * Location's address
     * @type {AddressViewModel}
     */
    this.address = address ? new AddressViewModel(address) : null

    /**
     * @type {Number}
     */
    this.clientId = clientId

    /**
     * @type {String}
     */
    this.clientName = clientName.trim()

    /**
     * @type {Number}
     */
    this.locationId = locationId

    /**
     * @type {String}
     */
    this.locationName = locationName.trim()

    const hasSameName =
      this.clientName === this.locationName || !this.locationName

    /**
     * Name to display in the UI. It's a combination of the client and location name.
     * If the loction name is the same or unset, it will just display the client name.
     * @type {String}
     */
    this.displayName = `${this.clientName}${hasSameName ? '' : ' - '}${
      hasSameName ? '' : this.locationName
    }`

    /**
     * Number of unfilled bookings
     * @type {Number}
     */
    this.openBookings = openBookings

    /**
     * Number of total bookings
     * @type {Number}
     */
    this.totalBookings = totalBookings
  }
}
